// extracted by mini-css-extract-plugin
export var container = "SearchResults-module--container--5hy0m";
export var highlight = "SearchResults-module--highlight--oH6Pd";
export var result = "SearchResults-module--result--BFdel";
export var showAll = "SearchResults-module--showAll--TKn+C";
export var showAllLink = "SearchResults-module--showAllLink--PzBVd";
export var text = "SearchResults-module--text--4D4p3";
export var wrapper = "SearchResults-module--wrapper--CFSWS";